import PolicyLayout from './PolicyLayout';
import { COMPANY_NAME, POLICY_UPDATED, SITE_DOMAIN } from '../constants/site';

export default function TermsOfService() {
  return (
    <PolicyLayout
      title="Terms of Service"
      updated={POLICY_UPDATED}
      intro={`By using this site or engaging ${COMPANY_NAME} through ${SITE_DOMAIN} you agree to the terms below.`}
    >
      <h2>Our services</h2>
      <p>
        We provide accounting software diagnostics, data file repair, bookkeeping support and
        the supply of authentic publisher licences. Advice given is technical and bookkeeping
        advice; it is not legal or regulated tax advice.
      </p>

      <h2>Independence</h2>
      <p>
        {COMPANY_NAME} is an independent provider. We are not affiliated with or endorsed by
        any accounting software publisher. Product names on this site are used only to
        describe the software categories we support.
      </p>

      <h2>Quotes and payment</h2>
      <p>
        Work begins only after you approve a written quote. The approved amount is the amount
        invoiced unless the scope changes and you agree to it in writing first.
      </p>

      <h2>Your responsibilities</h2>
      <p>
        You confirm that you are authorised to grant us access to the data you share, and that
        you hold a current backup of your accounting data file before any repair work begins.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        Our liability for any claim is limited to the fees paid for the specific engagement
        that gave rise to it. We are not liable for indirect losses, lost profits or data loss
        arising from backups outside our control.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms. The version published on this page at the time you engage
        us is the one that applies.
      </p>
    </PolicyLayout>
  );
}
